import { toast } from './toast'

export const copyToClipboard = (text: string, successMessage?: string) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success(successMessage || 'Copiado!')
    })
    .catch(() => {
      toast.error('Erro ao copiar.')
    })
}
